"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InmateSource = exports.getReadableDocType = exports.DocTypes = void 0;
var DocTypes;
(function (DocTypes) {
    DocTypes["ActivityAudit"] = "activity-audit";
    DocTypes["AutoEnrollRule"] = "auto-enroll-rule";
    DocTypes["AutoRegisterRule"] = "auto-register-rule";
    DocTypes["CourseEnrollment"] = "course-enrollment";
    DocTypes["Facility"] = "facility";
    DocTypes["Inmate"] = "inmate";
    DocTypes["StudentRegistration"] = "student-registration";
    DocTypes["SecurityAudit"] = "security-audit";
    DocTypes["Session"] = "session";
    DocTypes["CachedContent"] = "cached-content";
})(DocTypes = exports.DocTypes || (exports.DocTypes = {}));
function getReadableDocType(docType) {
    switch (docType) {
        case DocTypes.ActivityAudit: return 'ActivityAudit';
        case DocTypes.AutoEnrollRule: return 'AutoEnrollRule';
        case DocTypes.AutoRegisterRule: return 'AutoRegisterRule';
        case DocTypes.CourseEnrollment: return 'CourseEnrollment';
        case DocTypes.Facility: return 'Facility';
        case DocTypes.Inmate: return 'Inmate';
        case DocTypes.StudentRegistration: return 'StudentRegistration';
        case DocTypes.SecurityAudit: return 'SecurityAudit';
        case DocTypes.Session: return 'Session';
        case DocTypes.CachedContent: return 'cachedContent';
        default: return undefined;
    }
}
exports.getReadableDocType = getReadableDocType;
var InmateSource;
(function (InmateSource) {
    InmateSource["jpay"] = "jpay";
    InmateSource["svis"] = "svis";
})(InmateSource = exports.InmateSource || (exports.InmateSource = {}));
//# sourceMappingURL=doc.js.map